import React from "react";
import Navbar from "../../Navbar/Navbar";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";

const Hero = () => {
  return (
    <section className={styles.hero_mainContainer}>

      <Navbar />
      <MobileNavbar />

      {/* <div className={styles.hero_container}>
        <div className={styles.hero_content_container}>
          <div>
            <h1 className={styles.hero_heading}>DIGITAL HEALTHCARE</h1>
            <h1 className={styles.hero_heading}>ECOSYSTEM</h1>
          </div>

          <div className={styles.links_container}>
            <Link to='/products' className={styles.links_container__link}>
                All Products <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/products/products_healthcare' className={styles.links_container__link}>
            Health-Care Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/products/products_commercial' className={styles.links_container__link}>
            Commercial Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default Hero;
